import { Injectable } from '@angular/core';
import { FileService } from '@api/api/api';
import { FileUrl } from '@api/model/fileUrl';

@Injectable({
  providedIn: 'root'
})
export class FileManagerService {

  constructor(
    private readonly fileService: FileService,
  ) { }

  download(id: number, disposition: string): void {
    const promise = new Promise((resolve, reject) => {
      setTimeout(() => {
        this.fileService.getLinkById(id)
          .subscribe((fileUrl: FileUrl) => {
            window.open(fileUrl.url.replace('DISPOSITION', disposition)).addEventListener('load', (event) => {
              resolve();
            });
          });

      }, 1000);
    });

    promise.then(data => {
      this.fileService._delete(id)
        .subscribe();
    });
  }
}
